// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <div>
    <detail-view
    v-model="license"
    :buttons="buttons"
    disableModify
    :endpoint="endpoint + 'licenses'"
    name="License"
    permissions="licenses"
    :refresh="refresh"
    :values="values"
    ></detail-view>
    <v-container fluid grid-list-md v-if="canModify">
      <v-layout row wrap>
        <v-flex xs12 justify-center>
          <v-card>
            <v-card-text>
              <v-select
              
              label="License Type (select an item to populate menu)"
              item-text="text"
              return-object
              :items="item.licenseTypes"
              v-model="license.licenseType"
              hide-details
              required
              >
              </v-select>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <error-snackbar v-model="errorText"></error-snackbar>
  </div>
</template>

<script>
import moment from 'moment'

import ApiRequests from '@/api/ApiRequests'
import {ENDPOINT} from '@/shared/constants'
import DetailView from 'vue-common/components/DetailView.vue'

import ErrorSnackbar from 'vue-common/components/ErrorSnackbar'

export default {
  components: {
    DetailView,
    ErrorSnackbar
  },

  created () {
    ApiRequests.getLicenseFlavors().then((response) => {
      this.licenseFlavors = response.data
    })
  },

  computed: {
    canModify: function () {
      return this.$route.params.id === 'new'
    },

    buttons: function () {
      var b = []
      if (!this.canModify) {
        b.push({
          text: 'Refresh',
          function: () => this.refreshButton(),
          color: 'primary'
        })
        b.push({
          text: 'Deactivate',
          function: (x) => this.deactivateLicense(x),
          color: 'warning'
        })
      }
      return b
    }
  },

  methods: {
    deactivateLicense: function (item) {
      ApiRequests.deactivateLicense(item.fingerprint).then((response) => {
        this.errorText = 'License Deactivated'
      }).catch(e => {
        this.errorText = 'Deactivation Failed'
        console.log(e)
      })
    },

    formatTime: function (item) {
      return moment(item.timeCreated).format('YYYY-MM-DD hh:mm:ss A')
    },

    getDuration: function (value) {
      return value / 86400000000000
    },

    getLicenseFlavorText: function (flavor) {
      var full = this.licenseFlavors.find(el => el.id === flavor)
      if (full) {
        return full.name
      }
      return 'n/a'
    },

    refreshButton: function () {
      this.refresh = !this.refresh
    },

    textType: function () {
      for (var i in this.item.licenseTypes) {
        var x = this.item.licenseTypes[i]
        this.item.licenseTypes[i].text = 'Duration: ' + this.getDuration(x.duration) +
        ' days - Type: ' + this.getLicenseFlavorText(x.flavor)
      }
    }
  },

  watch: {
    'license.item': function () {
      ApiRequests.getLicenseItem(this.license.item).then((response) => {
        this.item = response.data
        this.textType()
      })
    }
  },

  data () {
    return {
      endpoint: ENDPOINT,
      errorText: '',
      item: {},
      license: {},
      licenseFlavors: [],
      refresh: false,
      values: [
        {
          name: 'Basic',
          items: [
            [

              {
                name: 'Customer',
                value: 'customer',
                context: ENDPOINT + 'customers',
                type: 'select',
                itemText: 'name',
                itemValue: '_id',
                required: true
              },
              {
                name: 'Item',
                value: 'item',
                context: ENDPOINT + 'items',
                type: 'select',
                itemText: 'name',
                itemValue: '_id',
                required: true
              }
            ],
            [
              {
                name: 'Active',
                value: 'active',
                type: 'checkbox',
                disabled: true
              },
              {
                type: 'duration',
                name: 'Duration (days)',
                value: 'licenseType.duration',
                disabled: true,
                valueType: 'days'
              },
              {
                name: 'Flavor',
                value: 'licenseType.flavor',
                context: ENDPOINT + 'licenseflavors',
                type: 'select',
                itemText: 'name',
                itemValue: 'id',
                disabled: true
              },
              {
                name: 'Issued',
                value: 'issued',
                type: 'date',
                disabled: true
              },
              {
                name: 'Expires',
                value: 'expires',
                type: 'date',
                disabled: true
              },
              {
                name: 'Last Access Time',
                value: 'timeAccessed',
                disabled: true
              }
            ],
            [
              {
                name: 'Fingerprint',
                value: 'fingerprint',
                disabled: true
              }
            ]
          ]
        },
        {
          name: 'Status',
          items: [
            [
              {
                text: 'Status',
                value: 'clientStatus',
                type: 'component',
                component: 'license-status'
              }
            ]
          ]
        },
        {
          name: 'Logs',
          items: [
            [
              {
                name: 'Logs',
                value: ENDPOINT + 'files',
                type: 'itemList',
                id: 'id',
                pagination: true,
                fileView: 'licenseEdit',
                filter: [{
                  name: 'tags',
                  value: 'fingerprint'
                }],
                allowDelete: true,
                editRoute: 'fileEdit',
                permissions: 'files',
                headers: [
                  {
                    text: 'Time Created',
                    value: 'timeCreated',
                    function: this.formatTime
                  },
                  {
                    text: 'Tags',
                    value: 'tags'
                  }
                ]
              }
            ]
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LicenseEdit.vue